import React from 'react'

const num = (v) => (v === null || v === undefined || v === '' ? '—' : String(v))

export const collegeList2Columns = (layout, role) => [
	{
		name: 'ID',
		selector: (row) => row.id,
		sortable: true,
		width: '70px',
		wrap: true
	},
	{
		name: 'Class',
		selector: (row) => row.class || '',
		sortable: true,
		width: '130px',
		cell: (row) => <div className="text-truncate" style={{ maxWidth: 100 }} title={row.class}>{row.class || '—'}</div>
	},
	{
		name: 'College',
		selector: (row) => row.college_name || '',
		sortable: true,
		minWidth: '160px',
		cell: (row) => <div className="text-truncate" style={{ maxWidth: 200 }} title={row.college_name}>{row.college_name || '—'}</div>
	},
	{
		name: 'State',
		selector: (row) => row.state || '',
		sortable: true,
		width: '70px'
	},
	{
		name: 'City',
		selector: (row) => row.city || '',
		sortable: true,
		width: '100px',
		cell: (row) => <div className="text-truncate" style={{ maxWidth: 110 }} title={row.city}>{row.city || '—'}</div>
	},
	{
		name: 'Rank',
		selector: (row) => row.ranking ?? '',
		sortable: true,
		width: '80px'
	},
	{
		name: 'GPA',
		selector: (row) => row.gpa ?? '',
		sortable: true,
		width: '75px'
	},
	{
		name: 'Accept %',
		selector: (row) => row.acceptance ?? '',
		sortable: true,
		width: '105px'
	},
	{
		name: '0–10%',
		selector: (row) => row['0_10'] ?? '',
		sortable: true,
		width: '70px'
	},
	{
		name: '1–11%',
		selector: (row) => row['1_11'] ?? '',
		sortable: true,
		width: '70px'
	},
	{
		name: '26–50%',
		selector: (row) => row['26_50'] ?? '',
		sortable: true,
		width: '75px'
	},
	{
		name: '51–75%',
		selector: (row) => row['51_75'] ?? '',
		sortable: true,
		width: '75px'
	},
	{
		name: '76–100%',
		selector: (row) => row['76_100'] ?? '',
		sortable: true,
		width: '80px'
	},
	{
		name: 'SAT',
		selector: (row) => `${num(row.low_sat)}–${num(row.high_sat)}`,
		sortable: false,
		width: '110px'
	},
	{
		name: 'ACT',
		selector: (row) => `${num(row.low_act)}–${num(row.high_act)}`,
		sortable: false,
		width: '100px'
	},
	{
		name: 'Tuition',
		selector: (row) => row.tuition ?? '',
		sortable: true,
		width: '90px'
	},
	{
		name: 'UG Enroll',
		selector: (row) => row.undergraduate_enrollment ?? '',
		sortable: true,
		width: '95px'
	},
	{
		name: 'Actions',
		selector: (row) => row.id,
		sortable: false,
		width: '120px',
		cell: (row) => (
			<div className="d-flex gap-2">
				<a href={`${process.env.PUBLIC_URL}/${role}/college-list-2/edit/${row.id}/${layout}`} className="btn btn-success btn-sm">
					<i className="fa fa-edit me-1"></i>
				</a>
				{row.onDelete && (
					<button type="button" className="btn btn-danger btn-sm" onClick={row.onDelete}>
						<i className="fa fa-trash"></i>
					</button>
				)}
			</div>
		)
	}
]
